import { render, staticRenderFns } from "./HypothesisParameter.vue?vue&type=template&id=97894024&"
import script from "./HypothesisParameter.vue?vue&type=script&lang=js&"
export * from "./HypothesisParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports